module.exports = __webpack_public_path__ + "img/header_bg.734d223e.png";